import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchFromBackoffice, PostBackoffice } from "../../../utils/request";
import { SavingReducer } from "../general";
import { addAlert, deleteAlert, fetchAlertData, fetchAlertTypes, initialMachineAlertState, updateAlertEmail } from "../../thunks/machineAlertsThunks";


const machineAlertSlice = createSlice({
  name: "machineAlertData",
  initialState: initialMachineAlertState,
  reducers: {
    resetSavingStatus: (state) => {
      state.saving = 'ready';
      state.lastError = "null";
    },
  },
  extraReducers: (builder) => {
    builder
    //---- QUERIES (Get)-----)
    .addCase(fetchAlertData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAlertData.fulfilled, (state, action) => {
        state.alertData = action.payload;
        state.loading = false;
      })
      .addCase(fetchAlertTypes.pending, (state) => {
        state.typesLoading = true;
      })
      .addCase(fetchAlertTypes.fulfilled, (state, action) => {
        state.alertTypes = action.payload;
        state.typesLoading = false;
      })
      //----COMMANDS (Add, Update, Delete)-----
      .addCase(updateAlertEmail.pending, (state) => {
        state.saving = "saving";
      })
      .addCase(updateAlertEmail.fulfilled, (state, action) => {
        state.alertData = state.alertData.map((alert) =>
          alert.alertId === action.payload.alertId
            ? { ...alert, emailRecipient: action.payload.newEmail }
            : alert,
        );
        state.saving = "saved";
      })
      .addCase(updateAlertEmail.rejected, (state, action) => {
        state.saving = "failed";
        console.error(action.payload)
      })
      .addCase(deleteAlert.pending, (state) => {
        state.saving = "saving";
      })
      .addCase(deleteAlert.fulfilled, (state, action) => {
        state.alertData = state.alertData.filter(
          (alert) => alert.alertId !== action.payload.alertId
        );
        state.saving = "saved";
      })
      .addCase(deleteAlert.rejected, (state, action) => {
        state.saving = "failed";
        console.error(action.payload)
      })
      .addCase(addAlert.pending, (state) => {
        state.saving = "saving";
        state.lastError = null;
      })
      .addCase(addAlert.fulfilled, (state, action) => {
        state.alertData.push(action.payload);
        state.saving = "saved";
      })
      .addCase(addAlert.rejected, (state, action) => {
        state.saving = "failed";
        state.lastError = action.payload as string;
        console.error(action.payload)        
      });
  },
});

export const { resetSavingStatus } = machineAlertSlice.actions;
export default machineAlertSlice.reducer;
